import type { ReactElement } from 'react'
import { PaperGrad, BeadyEye, STROKE, SHADOW, type GlyphProps } from './shared'

/* KOI / FISH — side view with fan tail and folded fins */
export const Fish = ({ size = 110 }: GlyphProps): ReactElement => (
  <svg width={size} height={size} viewBox="0 0 120 120" style={SHADOW}>
    <defs>
      <PaperGrad id="fish-l" light="#dff0fa" dark="#9bc8e6"/>
      <PaperGrad id="fish-d" light="#9bc8e6" dark="#5a90bf"/>
    </defs>
    {/* tail fan */}
    <polygon points="84,60 116,28 108,60 116,92" fill="url(#fish-d)" stroke={STROKE} strokeWidth="2" strokeLinejoin="round"/>
    <line x1="84" y1="60" x2="116" y2="28" stroke={STROKE} strokeWidth="0.7" strokeDasharray="2 2"/>
    <line x1="84" y1="60" x2="116" y2="92" stroke={STROKE} strokeWidth="0.7" strokeDasharray="2 2"/>
    <line x1="84" y1="60" x2="108" y2="60" stroke={STROKE} strokeWidth="0.7" strokeDasharray="2 2"/>
    {/* body diamond */}
    <polygon points="6,60 64,26 92,60 64,94" fill="url(#fish-l)" stroke={STROKE} strokeWidth="2.2" strokeLinejoin="round"/>
    {/* head shaded fold */}
    <polygon points="6,60 38,46 38,74" fill="url(#fish-d)" opacity="0.7" stroke={STROKE} strokeWidth="0.8" strokeDasharray="2 2" strokeLinejoin="round"/>
    {/* dorsal fin */}
    <polygon points="60,28 72,10 78,30" fill="url(#fish-l)" stroke={STROKE} strokeWidth="1.6" strokeLinejoin="round"/>
    {/* ventral fin */}
    <polygon points="60,92 72,110 78,90" fill="url(#fish-l)" stroke={STROKE} strokeWidth="1.6" strokeLinejoin="round"/>
    {/* creases */}
    <line x1="64" y1="26" x2="64" y2="94" stroke={STROKE} strokeWidth="0.7" strokeDasharray="2 2"/>
    <line x1="38" y1="60" x2="92" y2="60" stroke={STROKE} strokeWidth="0.6" strokeDasharray="2 2"/>
    <BeadyEye cx={22} cy={56} r={2}/>
  </svg>
)
